import { Button } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { recoverPassword } from "../../services/forgotEmail";
import InfoModal from "../util/confirmModal/InfoModal";
import { useTranslation } from "react-i18next";


const CambiarContrasena = () => {

    const { t } = useTranslation();

    const { code } = useParams();

    const navigate = useNavigate();

    // PASSWORD RECOVERY STATE
  
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [errorPassword, setErrorPassword] = useState(null);
    const [isLoadingPassword, setIsLoadingPassword] = useState(false);

    const modalInfoDefault = {
        infoTitle: '',
        infoMessage: '',
        infoIsOpen: false,
        infoIsError: false,
    }

    const [
        {
            infoTitle,
            infoMessage,
            infoIsOpen,
            infoIsError
        },
        setInfoModal
    ] = useState(modalInfoDefault)

    const infoCallback = () => {
        setInfoModal(modalInfoDefault);
        navigate('/');
    }

    const checkErrors = async () => {
        if (!newPassword || !confirmNewPassword) {
            setErrorPassword(t('PASSWORD_REQUIRED'));
            return true;
        }
        if (newPassword.length < 6) {
            setErrorPassword(t('PASSWORD_MIN_LENGTH'));
            return true;
        }
        if (newPassword !== confirmNewPassword) {
            setErrorPassword(t('PASSWORDS_DO_NOT_MATCH'));
            return true;
        }
        setErrorPassword(null);
        return false;
    }

    const requestChangePassword = async () => {
        setIsLoadingPassword(true);
        const hasError = await checkErrors();
        if (hasError) {
            setIsLoadingPassword(false);
            return;
        }
        try{
            const response = await recoverPassword(code, newPassword);
            setInfoModal({
                infoTitle: t('SUCCESS'),
                infoMessage: t('PASSWORD_CHANGED_SUCCESS'),
                infoIsOpen: true,
                infoIsError: false
            });
        } catch (error) {
            setInfoModal({
                infoTitle: t('ERROR'),
                infoMessage: t('PASSWORD_CHANGE_ERROR'),
                infoIsOpen: true,
                infoIsError: true
            });
        } finally {
            setIsLoadingPassword(false);
        }
    }
    
    return (
        <div className="d-flex flex-row vh-100 bg-dark justify-content-center align-items-center">
            <div className="d-flex text-light flex-column justify-content-between align-items-center" style={{maxWidth: '100%', width: '400px'}}>
                <header>
                    <img
                        alt="Campina logo"
                        className="logo py-2"
                        src="/assets/Logo-sin-fondo-blanco.png"
                        width="250"
                        height="250"
                    />
                </header>
                <input
                    type="password"
                    className="form-control my-2"
                    value={newPassword}
                    placeholder={t('NEW_PASSWORD')}
                    onChange={(e) => {
                        e.preventDefault();
                        setNewPassword(e.target.value);
                    }}
                    onBlur={checkErrors}
                />
                <input
                    type="password"
                    className="my-2 form-control"
                    value={confirmNewPassword}
                    placeholder={t('CONFIRM_NEW_PASSWORD')}
                    onChange={(e) => {
                    e.preventDefault();
                        setConfirmNewPassword(e.target.value);
                    }}
                    onBlur={checkErrors}
                />
                {errorPassword ? (
                    <div className="text-danger">Error: {errorPassword}</div>
                ) : null}
                <br />
                <Button
                    my="5"
                    colorScheme="yellow"
                    onClick={requestChangePassword}
                    disabled={isLoadingPassword}
                    opacity={isLoadingPassword ? 0.5 : 1}
                    isLoading={isLoadingPassword}
                    loadingText={t('CHANGING_PASSWORD')}
                    style={{ cursor: isLoadingPassword ? 'not-allowed' : 'pointer' }}
                >
                    {t('CHANGE_PASSWORD')}
                </Button>
            </div>
            <InfoModal
                isOpen={infoIsOpen}
                onClose={() => {
                    setInfoModal(modalInfoDefault);
                    infoCallback();
                }}
                title={infoTitle}
                message={infoMessage}
                isError={infoIsError}
                isSuccess={!infoIsError}
            />
        </div>
    )
    
}


export default CambiarContrasena;